import axios from 'axios';

const API_BASE_URL = 'https://book-lovers-4592.onrender.com';



const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor for Authorization
api.interceptors.request.use((config) => {
  const user = JSON.parse(sessionStorage.getItem('user'));
  if (user && user.token) {
    config.headers['Authorization'] = `Bearer ${user.token}`;
  }
  return config;
}, (error) => Promise.reject(error));


// Response Interceptor for Error Handling and Token Refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized! Logging out...");
      sessionStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// API Functions
export const getBooks = async () => {
  const response = await api.get('/books');
  return response.data;
};

export const toggleFavorite = async (bookId) => {
  const response = await api.post(`/books/toggleFavorite/${bookId}`);
  return response.data;
};

export const getUserProfile = async (userId) => {
  const response = await api.get(`/users/${userId}`);
  return response.data;
};

export const updateUserProfile = async (userId, userData) => {
  const response = await api.put(`/users/update/${userId}`, userData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const deleteUserProfile = async (userId) => {
  const response = await api.delete(`/users/delete-account/${userId}`);
  return response.data;
};

export const getUserBooks = async () => {
  const response = await api.get('/user/books');
  return response.data;
};

export const getUserBookshelf = async (userId) => {
  const response = await api.get(`/users/${userId}/bookshelf`);
  return response.data;
};

export const getUserFeed = async (userId) => {
  const response = await api.get(`/users/${userId}/feed`);
  return response.data;
};

export const getReviews = async () => {
  const response = await api.get('/reviews');
  return response.data;
};

export const addReview = async (reviewData) => {
  const response = await api.post('/reviews/add', reviewData);
  return response.data;
};

export default api;
